import highlightElement from "./highlightElement";

interface ScrollToElementInterface {
  $el: JQuery;
  $container?: JQuery | 'closest';
  highlightClass?: string;
  relative?: boolean;
  offset?: number;
  $horizontalContainer?: JQuery;
  horizontalOffset?: number;
  callback?: ($el: JQuery, $container: JQuery) => Promise<any>
}

export default async function scrollToElement({
                                          $el = null,
                                          $container = $('html, body'),
                                          highlightClass = 'highlight',
                                          relative = false,
                                          offset = 0,
                                          $horizontalContainer = null,
                                          horizontalOffset = offset,
                                          callback = null,
                                        }: ScrollToElementInterface): Promise<{$el: JQuery, $container: JQuery} | void> {
  const $scrollContainer = $container === 'closest' ? $(getScrollParent($el[0])) : $container
  if($scrollContainer.is('html, body')) relative = false
  $horizontalContainer = $horizontalContainer || $scrollContainer

  const scrollTop = (() => {
    if (relative) {
      if (!$scrollContainer.length) return 0

      return $scrollContainer.scrollTop() + $el.offset().top - $scrollContainer.offset().top - 10 + offset;
    } else if ($el && $el.length > 0) {
      return $el.offset().top + offset;
    }
  })();

  const scrollLeft = (() => {
    if (relative) {
      if (!$horizontalContainer.length) return 0

      return $horizontalContainer.scrollLeft() + $el.offset().left - $horizontalContainer.offset().left - 10 + horizontalOffset;
    } else if ($el && $el.length > 0) {
      return $el.offset().left + horizontalOffset;
    }
  })();

  await $scrollContainer.animate(
    {
      scrollTop: scrollTop,
    },
    {
      duration: 200,
      done: () => {
        if ($horizontalContainer) {
          $horizontalContainer.animate(
            {
              scrollLeft: scrollLeft,
            },
            {
              duration: 200,
              done: () => {
                highlightElement({$el, highlightClass});
                callback?.($el, $scrollContainer)
              }
            },
          )
        } else {
          highlightElement({$el, highlightClass});
          callback?.($el, $scrollContainer)
        }
      }
    }
  )
  await new Promise(resolve => {
    resolve({$el, $scrollContainer})
  });
}


function getScrollParent(node) {
  if (node === null) {
    return null;
  }

  if (node.scrollHeight - node.clientHeight > 50) {
    return node;
  } else {
    return getScrollParent(node.parentNode);
  }
}

